import { viewTexts } from '../../../constants/view-texts';
import { ModelStatus } from '../../../types/enum/model-status';

const vt = viewTexts.pages.modelImageList;

export const toMessageAreaValue = (modelStatus: ModelStatus) => ({
  status: modelStatus === 'failed' ? ('alert' as const) : ('default' as const),
  message: (() => {
    switch (modelStatus) {
      case 'created':
        return []; // dummy
      case 'annotating':
        return vt.messages.annotationInCompleted;
      case 'annotated':
        return vt.messages.annotationCompleted;
      case 'training':
        return vt.messages.trainingRunning;
      case 'available':
        return vt.messages.modelIsAvailable;
      case 'failed':
        return vt.messages.trainingError;
    }
  })(),
  showStartTrainingButton:
    modelStatus === 'annotated' ||
    modelStatus === 'available' ||
    modelStatus === 'failed'
});
